import {apsServiceTypes} from '@ace-de/eua-entity-types';

const budgetedMaxDurationServiceTypes = [
    apsServiceTypes.ACCOMMODATION,
    apsServiceTypes.RENTAL_CAR__DOMESTIC_DAILY,
];

export default budgetedMaxDurationServiceTypes;
